"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEFAULT = exports.DEFAULT = "Default"; //Ready might be better..?

/**
 *
 * Running/executing code
 * @type {string}
 */

var RUNNING = exports.RUNNING = "Running"; //TODO: RUNNING_CODE instead..?

/**
 * Successfully ran code
 * @type {string}
 */

var PASSED = exports.PASSED = "Passed";
/**
 * Failed against tests
 * @type {string}
 */

var FAILED = exports.FAILED = "Failed";
/**
 *
 * Successfully submitted
 * @type {string}
 */

var DONE = exports.DONE = "Done";
/**
 *
 * Ready for next task
 * @type {string}
 */

var READY_FOR_NEXT = exports.READY_FOR_NEXT = "Ready";